export default __webpack_public_path__ + "static/logo-4-4adedfb46f7bd8e00c8cdd24bf9c7eaa.jpeg";